import axios from 'axios';

import { BenchmarkDateRange } from 'views/benchmark-analytics/types/benchmark-filters.type';
import { USE_GROWTH_MOCK_DATA } from '../constants/growth';
import { generateGrowthBenchmarkMock, generateGrowthSiteDataMock } from '../mock/growth.mock';
import { GrowthResponse } from '../types/growth-series.type';

const toParams = (dateRange: BenchmarkDateRange) => ({ fromDate: dateRange.from, toDate: dateRange.to });

// GET
export const getGrowthBenchmark = async (globalCompanyId: string, dateRange: BenchmarkDateRange): Promise<GrowthResponse> => {
  if (USE_GROWTH_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 400));
    return generateGrowthBenchmarkMock(globalCompanyId, dateRange);
  }
  const res = await axios.get<GrowthResponse>(`/ewosapi/v1/shrimps/benchmarkanalytics/growth/${globalCompanyId}`, {
    params: toParams(dateRange),
  });
  return res.data;
};

// POST
export const getGrowthSiteData = async (
  globalCompanyId: string,
  globalSiteIds: string[],
  dateRange: BenchmarkDateRange
): Promise<GrowthResponse> => {
  if (USE_GROWTH_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 400));
    return generateGrowthSiteDataMock(globalSiteIds, dateRange);
  }
  const res = await axios.post<GrowthResponse>(`/ewosapi/v1/shrimps/benchmarkanalytics/growth/${globalCompanyId}/site-data`, {
    ...toParams(dateRange),
    globalSiteIds,
  });
  return res.data;
};
